var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 11.33c-1.934 0-3.014 1.92-2.574 3.347l-4.733 4.747c-.4-.12-.987-.12-1.387 0l-3.4-3.4c.454-1.427-.626-3.36-2.573-3.36-1.933 0-3.027 1.92-2.573 3.36l-6.08 6.067c-1.427-.44-3.347.64-3.347 2.573 0 1.467 1.2 2.667 2.667 2.667 1.933 0 3.013-1.92 2.573-3.347l6.067-6.08c.4.12.986.12 1.386 0l3.4 3.4c-.453 1.427.627 3.36 2.574 3.36 1.933 0 3.026-1.92 2.573-3.36l4.747-4.733c1.426.44 3.346-.64 3.346-2.574 0-1.466-1.2-2.666-2.666-2.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 12.664 1.253-2.76L24 8.664l-2.747-1.24L20 4.664l-1.227 2.76L16 8.664l2.773 1.24L20 12.664ZM4.666 15.33l.667-2.666L8 11.997l-2.667-.666-.667-2.667L4 11.331l-2.667.666L4 12.664l.666 2.667Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.0dc19cf9da6860ec2515d00e990f2a87.svg";
export { ForwardRef as ReactComponent };